import React from 'react';
import { Helmet } from 'react-helmet';

const Services = () => {
  const services = [
    {
      id: 1,
      image: '/images/manic-5.jpg',
      title: 'PROMO MANUCURE',
      discount: '-20%',
      badge: 'Offre limitée',
      description: "Profitez d'une remise exceptionnelle sur votre manucure classique.",
    },
    {
      id: 2,
      image: '/images/ped-2.png',
      title: 'PROMO PÉDICURE',
      discount: '-10%',
      badge: 'Offre saisonnière',
      description: 'Relaxez-vous avec une pédicure professionnelle à prix réduit.',
    },
    {
      id: 3,
      image: '/images/banner_ing2.jpg',
      title: 'FORMATION MANUCURE',
      badge: 'Cours pro',
      description: 'Apprenez les techniques modernes de manucure dans nos ateliers.',
    },
    {
      id: 4,
      image: '/images/ped2.png',
      title: 'FORMATION PÉDICURE',
      badge: 'Cours intensif',
      description: 'Formation complète pour devenir pro en soin des pieds.',
    },
    {
      id: 5,
      image: '/images/manic_7.jpg',
      title: 'Manucure classique',
      badge: 'Service standard',
      description: 'Nail care, limage, polissage et vernis simple inclus.',
    },
    {
      id: 6,
      image: '/images/manic_pers.png',
      title: 'Manucure Personnelle',
      badge: 'Sur mesure',
      description: 'Un service adapté à vos goûts et besoins personnels.',
    },
    {
      id: 7,
      image: '/images/rolong_1.jpg',
      title: 'Rallongement',
      badge: 'Ongles longs',
      description: "Pose d'extensions avec gel ou acrylique.",
    },
    {
      id: 8,
      image: '/images/ped2.png',
      title: 'Soins des PIEDS',
      badge: 'Relaxation',
      description: 'Hydratation, massage et traitement complet pour vos pieds.',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Services | Royal Nails Pro - Manucure, Pédicure, Nail Art Genève</title>
        <link rel="canonical" href="https://royalnailspro.ch/services" />
        <meta
          name="description"
          content="Découvrez nos services de manucure, pédicure, nail art, extensions ongles et formations professionnelles à Genève. Promotions et offres spéciales disponibles."
        />
        <meta
          name="keywords"
          content="services manucure Genève, pédicure Genève, nail art Genève, extensions ongles, formation manucure, promo manucure, promo pédicure, soins ongles Genève, manucure gel, pédicure spa"
        />
        
        {/* Open Graph / Facebook & Instagram */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://royalnailspro.ch/services" />
        <meta property="og:title" content="Services | Royal Nails Pro - Manucure, Pédicure, Nail Art Genève" />
        <meta property="og:description" content="Découvrez nos services de manucure, pédicure, nail art, extensions ongles et formations professionnelles à Genève." />
        <meta property="og:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:secure_url" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="Services Royal Nails Pro" />
        <meta property="article:author" content="https://www.facebook.com/people/Rodyka-Soltan/61572131475024/" />
        
        {/* Instagram specific */}
        <meta property="instagram:creator" content="@rodyka_soltan" />
        
        {/* TikTok */}
        <meta name="tiktok:creator" content="@rodicasoltan" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Services | Royal Nails Pro" />
        <meta name="twitter:description" content="Découvrez nos services de manucure, pédicure, nail art et formations professionnelles." />
        <meta name="twitter:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta name="twitter:site" content="@rodyka_soltan" />
        <meta name="twitter:creator" content="@rodyka_soltan" />
      </Helmet>

      <div className="back_re">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <h2>Royal Nails Pro</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pricing slin">
        <div className="container">
          <h2 className="section-title">Nos Offres & Services</h2>
          <div className="pricing-grid">
            {services.map((service) => (
              <div key={service.id} className="pricing_item">
                <div className="pricing_box_ti">
                  <div className="circle-img">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <h3>
                    {service.title} {service.discount && <span>{service.discount}</span>}
                  </h3>
                </div>
                <div className="our_pricing">
                  <span>{service.badge}</span>
                  <p>{service.description}</p>
                </div>
                <div className="pricing_cta">
                  <a
                    className="read_more mar_top"
                    href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
                  >
                    Reserver
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;

